import { render } from "./MscSeminar2023.vue?vue&type=template&id=2d5b0124&scoped=true"
import script from "./MscSeminar2023.vue?vue&type=script&lang=js"
export * from "./MscSeminar2023.vue?vue&type=script&lang=js"

import "../../assets/css/custom.css?vue&type=style&index=0&id=2d5b0124&scoped=true&lang=css"
import "../../assets/css/module.css?vue&type=style&index=1&id=2d5b0124&scoped=true&lang=css"
import "../../assets/css/module_sp.css?vue&type=style&index=2&id=2d5b0124&scoped=true&lang=css"
import "../../assets/css/top.css?vue&type=style&index=3&id=2d5b0124&scoped=true&lang=css"
import "./MscSeminar2023.vue?vue&type=style&index=4&id=2d5b0124&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d5b0124"]])

export default __exports__